import * as React from 'react';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import { message, Modal } from 'antd';
import './index.css';

class CaseDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      detail: null,
      modalVisible: false,
    };
  }
  UNSAFE_componentWillMount() {
    console.log('this.props.location.state.id: ', this.props.location.state.id);
    if (this.props.location.state.id) {
      this.setState({ id: this.props.location.state.id }, () => {
        this.getDetail();
      });
    }
  }
  // 获取详情
  getDetail = async () => {
    const res = await https.get(Urls.getEnterpriseCaseDetail.replace('{id}', this.state.id), {});
    console.log('详情: ', res);
    if (!res.success) {
      message.error('获取详情失败');  
      return;
    }
    this.setState({ detail: res.data });
  }
  showModal = () => {
    this.setState({
      modalVisible: true
    });
  }
  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  }
  render() {
    const detail = this.state.detail;
    return (
      <React.Fragment>
        <div className="case"></div>
        {
          detail &&
          <div className="case-list">
            <div className="text">{detail.name}</div>
            <div className="box-list">
              <div className="list-left" style={{ background: '#fff' }}>
                {
                  detail.content &&

                  <img src={detail.content} alt="" style={{ width: '6.53rem', height: '5.49rem' }} onClick={this.showModal}/>
                }
              </div>
              <div className="list-right">
                <div className="cont">
                  <div>如果您希望对我们的技术流程有更多了解，</div>
                  <div>或您已有意愿进行深入合作，</div>
                  <div>希望我们帮您开发定制解决方案，</div>
                  <div>请马上联系我们！</div>
                </div>
                <div className="m-box">
                  <div className="mailbox">
                  <div className="logo"></div>
                  <div className="number">邮箱地址：{detail.email}</div>
                </div>
                <div className="mailbox">
                  <div className="logo numb"></div>
                  <div className="number">联系方式：{detail.tel}（季博士）</div>
                </div>
                </div>
                
              </div>
            </div>
          </div>
        }
        <Modal 
          title="" 
          visible={this.state.modalVisible} 
          onCancel={this.handleCancel}
          footer={null}
          centered={true}
          width="auto"
          className="img-modal"
        >
          <img src={detail?.content} alt=""/>
        </Modal>
      </React.Fragment >
    );
  }
}

export default CaseDetail;
